import { TGet_companies_listQuery } from 'services/SwaggerApi';

import { TableCompaniesHeaderFields } from '../Header/Header.types';

export const serializeFilters =
    (filters: TableCompaniesHeaderFields): TGet_companies_listQuery => ({
        name: filters.companyName,
        travel_policy_id: filters.travelPolicy?.id ? Number(filters.travelPolicy.id) : undefined,
    });
